import { render, staticRenderFns } from "./collect-job.vue?vue&type=template&id=ce8e082c"
import script from "./collect-job.vue?vue&type=script&lang=js"
export * from "./collect-job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports